export default __webpack_public_path__ + "static/media/logo-senatu.efd49e0f.jpg";